export default __webpack_public_path__ + "static/media/payroll-feature-compliance.0ab4c219.svg";